




































































import Vue from 'vue'
import { KeyActionEnum, SecurityArea, SecurityComponent, SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'
import { hexToRgba } from '@/services/hex-to-rgba'
import ProgressCircular from '@/components/ProgressCircular.vue'
import * as securityService from '@/services/security-service'
import Documents from '@/components/Documents.vue'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'
import TicketingRequest from '@/components/ticketing/TicketingRequest.vue'
import TicketingLinked from '@/components/ticketing/TicketingLinked.vue'
import TicketingSteps from '@/components/ticketing/TicketingSteps.vue'
import TicketingReporting from '@/components/ticketing/TicketingReporting.vue'
import WarningDialog from '@/components/WarningDialog.vue'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}
class Search extends KeyAction {}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  activeTab: number
  ticketDetail: any | null
  selectedTicketId: number | undefined
  ticketIdIndex: number

  isCreateTicket: boolean
  isEditTicket: boolean
  showWarningDialog: boolean
  warningMessage: string
  loadingEdit: boolean

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'TicketingWindow',

  components: {
    WarningDialog,
    ProgressCircular,
    TicketingRequest,
    Documents,
    TicketingLinked,
    TicketingSteps,
    TicketingReporting
  },

  props: {
    showDialog: Boolean,
    ticketingIdList: Array as () => number[],
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      activeTab: 0,
      ticketDetail: null,
      selectedTicketId: undefined,
      ticketIdIndex: 0,

      isCreateTicket: false,
      isEditTicket: false,
      showWarningDialog: false,
      warningMessage: '',
      loadingEdit: false,

      keyActions: []
    }
  },

  watch: {
    activeTab (newVal: number): void {
      if(this.$route.path === '/ticketing') {
        let data: any = this.getRouteData()
        data.ticketingTab = newVal
        this.$router.push({ name: 'Ticketing', query: { data: JSON.stringify(data) } })
      }
    }
  },

  computed: {
    getLogo (): string {
      return require('@/assets/pin_green.png')
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isTicketBeforeDisabled (): boolean {
      return this.ticketIdIndex === 0
    },

    isTicketAfterDisabled (): boolean {
      return this.ticketIdIndex === this.ticketingIdList.length -1
    },

    showInsertButton (): boolean {
      return securityService.isVisible(SecurityArea.Addresses, SecurityComponent.IconInsert)
    },

    isDisabledInsertButton (): boolean {
      return securityService.isDisabled(SecurityArea.Addresses, SecurityComponent.IconInsert)
    },

    showUpdateButton (): boolean {
      return securityService.isVisible(SecurityArea.Addresses, SecurityComponent.IconUpdate)
    },

    isDisabledUpdateButton (): boolean {
      return securityService.isDisabled(SecurityArea.Addresses, SecurityComponent.IconUpdate)
    },

    showDeleteButton (): boolean {
      return securityService.isVisible(SecurityArea.Addresses, SecurityComponent.IconDelete)
    },

    isDisabledDeleteButton (): boolean {
      return securityService.isDisabled(SecurityArea.Addresses, SecurityComponent.IconDelete)
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | Search | null): boolean {
      if(action instanceof Create && this.activeTab === 1 || this.activeTab === 5) {
        return !this.isEditTicket
      } else if(action instanceof Edit && this.activeTab === 1 || this.activeTab === 5) {
        return !this.isEditTicket
      } else if(action instanceof Delete && this.activeTab === 1 || this.activeTab === 5) {
        return !this.isEditTicket
      } else if(action instanceof Search && this.activeTab !== 4) {
        return true
      } else {
        return false
      }
    },

    onAddTicketClick (): void {
      this.create()
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.activeTab = 0
      this.isEditTicket = false
      this.isCreateTicket = true
    },

    onEditTicketClick (): void {
      this.update()
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.activeTab = 0
      this.isEditTicket = true
      this.isCreateTicket = false
    },

    onDeleteTicketClick (): void {
      this.delete()
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.warningMessage = this.$t('project.deleteProjectMessage').toString()
      this.showWarningDialog = true
    },

    onWarningDialogClose (): void {
      this.showWarningDialog = false
    },

    async onWarningDialogSave (): Promise<void> {
      this.showWarningDialog = false
      if(this.selectedTicketId) {

        try {

        } catch {
          this.loading = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    onTicketBeforeClick (): void {
      this.ticketIdIndex -= 1
      this.selectedTicketId = this.ticketingIdList[this.ticketIdIndex]
      let data: any = this.getRouteData()
      data.ticketIdIndex = this.ticketIdIndex
      this.$router.push({name: 'Ticketing', query: { data: JSON.stringify(data) }})
      this.fetchData()
    },

    onTicketAfterClick (): void {
      this.ticketIdIndex += 1
      this.selectedTicketId = this.ticketingIdList[this.ticketIdIndex]
      let data: any = this.getRouteData()
      data.ticketIdIndex = this.ticketIdIndex
      this.$router.push({name: 'Ticketing', query: { data: JSON.stringify(data) }})
      this.fetchData()
    },

    onSearchClick (): void {
      this.search()
    },

    search (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.$emit('close')
    },

    onCopyClick (): void {
      //COPY
    },

    onCloseDialog (): void {
      this.$emit('close')
    },

    onCancelRequestClick (): void {
      this.isCreateTicket = false
      this.isEditTicket = false
    },

    async fetchData (): Promise<void> {
      this.loading = true
      try {
        //this.ticketDetail = await this.$store.dispatch(GET_TICKET_DETAIL, this.selectedTicketId)
      } catch {

      } finally {
        this.loading = false
      }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    updateRoute (id: number): void {
      this.$emit('updateRoute', id)
      let routeData: any = this.getRouteData()
      routeData.selectedRowKeys = [id]
      routeData.ticketingTab = 0
      routeData.ticketIdIndex = 0
      this.$router.push({name: 'Ticketing', query: { data: JSON.stringify(routeData) }})
      setTimeout (() => {
        this.setDataFromRoute()
      }, 0)
    },

    setDataFromRoute (): void {
      let data: any = this.getRouteData()

      if(this.$route.path === '/ticketing') {
        this.ticketIdIndex = data && data.ticketIdIndex ? data.ticketIdIndex : 0
        if(this.ticketingIdList[this.ticketIdIndex]) {
          this.selectedTicketId = this.ticketingIdList[this.ticketIdIndex]
        } else {
          this.selectedTicketId = this.ticketingIdList[0]
        }
        this.activeTab = data.ticketingTab
      } else {
        this.ticketIdIndex = 0
        this.selectedTicketId = this.ticketingIdList[0]
      }
    }
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
      new Search(KeyActionEnum.search, this.search, this.resolver, null)
    ]
  },

  async mounted (): Promise<void> {
    window.addEventListener('keydown', this.onKeydown)
    this.setDataFromRoute()
    this.fetchData()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
